var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArticles = function SvgArticles(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 2H36V37C36 37.5523 35.5523 38 35 38H6V41C6 41.5523 6.44772 42 7 42H39C39.5523 42 40 41.5523 40 41V3C40 2.44772 39.5523 2 39 2Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 8V45C44 45.5523 43.5523 46 43 46H12V48H46V8H44Z",
    fill: "#FFE0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 6H42V3C42 1.34315 40.6569 0 39 0H7C5.34315 0 4 1.34315 4 3V41C4 42.6569 5.34315 44 7 44H10V47C10 48.6569 11.3431 50 13 50H45C46.6569 50 48 48.6569 48 47V9C48 7.34315 46.6569 6 45 6ZM6 41V3C6 2.44772 6.44772 2 7 2H39C39.5523 2 40 2.44772 40 3V41C40 41.5523 39.5523 42 39 42H7C6.44772 42 6 41.5523 6 41ZM45 48C45.5523 48 46 47.5523 46 47V9C46 8.44771 45.5523 8 45 8H42V41C42 42.6569 40.6569 44 39 44H12V47C12 47.5523 12.4477 48 13 48H45Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24H11C10.4477 24 10 24.4477 10 25C10 25.5523 10.4477 26 11 26H35C35.5523 26 36 25.5523 36 25C36 24.4477 35.5523 24 35 24Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30H11C10.4477 30 10 30.4477 10 31C10 31.5523 10.4477 32 11 32H27C27.5523 32 28 31.5523 28 31C28 30.4477 27.5523 30 27 30Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6H34C35.1046 6 36 6.89543 36 8V18C36 19.1046 35.1046 20 34 20H12C10.8954 20 10 19.1046 10 18V8C10 6.89543 10.8954 6 12 6ZM12 18H34V8H12V18Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArticles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/articles.2dc57844457228ddac5678a36bcf3ad6.svg";